module.exports = __webpack_public_path__ + "img/local-icon-five.5a9caf40.png";